module.exports = __webpack_public_path__ + "static/logo-824dc415df73f5038a7427bfbfee2c3d.png";